module.exports = __webpack_public_path__ + "static/media/videoOff.19151c17.png";